/* The one composer for people Chat and the agents (chat makeover #2718) */
.container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  border-style: solid;
  border-color: var(--tuna-palette-divider);
  background-color: var(--tuna-palette-action-hover);
  border-width: 1px;
  border-radius: var(--tuna-shape-radius-md);
}

/*
 * Composer focus ring accent (Joni §2). Neutral fallback keeps the human
 * Chat tool, which never sets `--agent-accent`, byte-identical.
 */
.container:focus-within {
  box-shadow: 0 0 0 2px var(--agent-accent, var(--tuna-focus-ring, transparent));
  border-radius: var(--tuna-shape-radius-sm);
}

.focus {
  display: flex;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
}

.avatar {
  flex-shrink: 0;
  align-self: flex-start;
}

/*
 * Two lines to start, growing to six, then scrolling. body1 (1rem, 16px) everywhere: the field must be at least 16px on phones,
 * or iOS zooms into it on focus.
 */
.editor {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 8px;
  font-size: var(--tuna-typography-body1-fontSize);
  line-height: var(--tuna-typography-body1-lineHeight);
  min-height: calc(2 * 1.5em);
  max-height: calc(6 * 1.5em);
  overflow-y: auto;
}

.hint {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
  padding-left: 32px;
}

/* 44px targets on touch */
@media (pointer: coarse) {
  .row :is(button) {
    min-height: 44px;
    min-width: 44px;
  }
}
